module.exports = __webpack_public_path__ + "media/QuickSort_slow.8d79ec14.mp4";